import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import * as showdown from "showdown";

@Injectable({
    providedIn: "root",
})
export class TermsOfUsePageService {
    TermsOfUsePageContent$ = new BehaviorSubject({} as any);
    public environment = environment;
    private markdownConverter: showdown.Converter;

    constructor(private http: HttpClient) {
        this.markdownConverter = new showdown.Converter();
    }

    init(): void {
        this.getContent().subscribe((res) => {
            const markdownContent = res?.content;
            const htmlContent = this.markdownConverter.makeHtml(markdownContent);
            this.TermsOfUsePageContent$.next(htmlContent);
        });
    }

    getContent(): Observable<any> {
        return this.http.get(`${this.environment.brain_base_url}/terms/terms/tou`);
    }
}
